/**
 * @file 知识库 NewRegionSelect 左侧富文本行（Layer 1 纯 UI）
 * 供 options.render 使用：标题高亮 + 文档数 + 相对更新时间
 */
import React from 'react';
import RelativeTimeText from './RelativeTimeText';
import DocCountText from './DocCountText';
import SearchAwareText from './SearchAwareText';

export interface IKbRichItemProps {
  /** 知识库名称 */
  name: string;
  /** 文档数量 */
  docCount?: number;
  /** 最后更新时间 */
  updatedAt?: string;
  /** 搜索高亮关键词（服务端搜索框） */
  highlightKeyword?: string;
}

/**
 * 知识库左侧富文本行（供 NewRegionSelect.options.render）
 */
export const KbRichItem: React.FC<IKbRichItemProps> = ({
  name,
  docCount = 0,
  updatedAt,
  highlightKeyword = '',
}) => (
  <div className="dba-kb-rich-item">
    <SearchAwareText
      name={name}
      className="dba-kb-rich-item-name"
      keyword={highlightKeyword}
    />
    <div className="dba-kb-rich-item-meta">
      <DocCountText count={docCount} />
      <span className="dba-kb-rich-item-dot">·</span>
      <RelativeTimeText updatedAt={updatedAt} />
    </div>
  </div>
);
